import BaseInput from 'source/lib/component/input/base';
import template from './template.html';

const RememberInput = BaseInput.extend({
    name: 'remember-input',
    template,

    initialize(...args) {
        BaseInput.prototype.initialize.apply(this, args);
        const checked = this.data['input-checked'] === 'true';

        this.checkbox = this.$('.js-input');
        this.checkboxUI = this.$('.js-checkbox');

        this.checkbox.prop('checked', checked);
    },
    events: {
        'change input': 'change',
        'click .js-checkbox-content': 'click'
    },
    change(event) {
        this.checkboxUI
            .toggleClass('js-checkbox-unchecked', !event.currentTarget.checked)
            .toggleClass('js-checkbox-checked', event.currentTarget.checked);
        this.value = event.currentTarget.checked;
        this.components.proxyEvent('change', event, this);
    },
    click() {
        this.checkbox[0].checked = !this.checkbox[0].checked;
        this.checkbox.trigger('change');
    }
});

export default RememberInput;



// WEBPACK FOOTER //
// ./static-source/js/lib/component/input/remember/index.js